// eslint-disable-next-line import/prefer-default-export
export function isInternalUser(id) {
    try {
        const internalIds = [
            '1069440166821281534',
            '874774465400199228',
            '364503266366295577',
            '831608565533089733',
            '1131858571128705619',
            'GnHgBCAREGUAx00mcALeHtuzl9B3',
            'WU3CexdPgJcR8ZzMsD5aQIKoU8S2',
            '1oMS5Dyr7WWoMgRqJOmDMtQlbjk1',
            'lB5tiwPX2oZJuymeR2dj92i8Qat1',
            'nOcZunJVG4QAe2qIbhq1oVWPqaz2', // jeremy rendition uid
        ];
        return id ? internalIds.includes(id) : false;
    }
    catch (e) {
        return false;
    }
}
